<template>
  <div id="menuComponent"
    v-if="!$store.state.user.status.loggedIn"
    class="menu-style style-col2"
    style="padding-right: 0px; max-height: 220px;"
  >
    <router-link exact tag="ul" :to="{name: 'cvapresentation'}">
      <li>Présentation de la carte</li>
    </router-link>

    <router-link exact tag="ul" :to="{name: 'assistanceassurances'}">
      <li>Assurances et assistance</li>
    </router-link>

    <router-link exact tag="ul" :to="{name: 'paiementsinternet'}">
      <li>Sécurité achats en ligne</li>
    </router-link>
  </div>

  <div id="menuConnecte" v-else class="menu-style style-col2" style="padding-right: 0px;margin-bottom: 120px;">
    <div v-for="thePageName in $store.state.user.user.pageNames" :key="thePageName.name">
      <div v-if="hasPermission(permissions, thePageName[3])">
        <router-link
          v-if="isClickable(thePageName[4])"
          :to="{name: thePageName[1].toLowerCase()}"
          tag="ul"
        >
          <li>{{ thePageName[2] }}</li>
        </router-link>
        <div v-else v-bind:style="getStyleRouterLink(thePageName)">
          <router-link
            :to="{name: thePageName[1].toLowerCase()}"
            exact tag="ul"
          >
            <li v-bind:class="getTabClass(thePageName)">{{ thePageName[2] }}</li>
          </router-link>
          </div>
        <ul
          v-if="isSeparator(thePageName[5])"
          style="padding-left: 0px; margin-top: -10px; margin-bottom: 10px;"
          v-bind:class="getMySeparator(thePageName[5])"
        ></ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.menu-style ul.router-link-active {
  color: black;
  transition: all 0.2s;
  list-style-image: url(../assets/puce_menu_fiche_f2.gif);
  background-color: white;
  margin-bottom: 0.5rem;

  li {
    color: black;
    padding-top: 5px;
    padding-bottom: 5px;
  }
}

.menu-style li {
  color: white;
  font-family: verdana, arial, Helvetica;
  font-weight: 600;
  cursor: pointer;
}

.Zone_Gauche_MenuRoot_Sep {
  background-color: #a5ce55;
  border-bottom: 1px dashed #c7e58a;
}
.Zone_Gauche_MenuRoot_SepInactif {
  background-color: #bbbbbb;
  border-bottom: 1px dashed #c7e58a;
}
.Zone_Gauche_MenuRootInactif {
  background-color: #bbbbbb;
  font-weight: 600;
  color: black !important;
  list-style-image: url(../assets/puce_menu2.png);
  cursor: auto !important;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: -10px;
  margin-bottom: -16px;
}

.col-12 {
  max-width: 96.5% !important;
}
</style>

<script>
import hasPermission from '@/utils/utils.js'

export default {
  data: function () {
    return {
      hasPermission,
      permissions: this.$store.state.user.user ? this.$store.state.user.user.permissions : [],
      listPages: this.$store.state.user.user ? this.$store.state.user.user.pageNames : []
    }
  },
  methods: {
    isSeparator (pattern) {
      if (pattern === '1') {
        return true
      } else {
        return false
      }
    },
    isThisInGrey () {
      if (this.$store.state.user.user.selectedEntreprise || this.$store.state.user.user.entrepriseId) {
        return false
      }
      return true
    },
    getTabClass (thePageName) {
      if (this.$route.name === thePageName[1].toLowerCase()) {
        return 'Zone_Gauche_MenuRootActif'
      } else {
        if (this.isThisInGrey() && thePageName[4] === '1') {
          return 'Zone_Gauche_MenuRootInactif'
        } else {
          return 'Zone_Gauche_MenuRoot'
        }
      }
    },
    getStyleRouterLink (thePageName) {
      if (this.$route.name === thePageName[1].toLowerCase()) {
        return null
      }
      return 'background-color: #bbbbbb; pointer-events: none;'
    },
    getMySeparator (pattern) {
      if (pattern === '1' && !this.isThisInGrey()) {
        return 'Zone_Gauche_MenuRoot_Sep'
      } else if (pattern === '1' && this.isThisInGrey()) {
        return 'Zone_Gauche_MenuRoot_SepInactif'
      }
      return ''
    },
    isClickable (pattern) {
      if (this.isThisInGrey() && pattern === '1') {
        return false
      } else {
        return true
      }
    }
  }
}
</script>
